import { goBack } from "assets/icons";
import styled from "@emotion/styled";
import {
  Card,
  Col,
  Row,
  Typography,
} from "antd";
import { useNavigate } from "react-router-dom";

import ModalAddUser from "./ModalAddUser";
import { useGetUserSystem } from "hooks/useAuth";
import { useAppSelector } from "store";
import UserSystemList from "./UserSystemList";
import React from "react";

const UserSystem = () => {
  const navigate = useNavigate();

  const contact = useAppSelector((state) => state.auth.contact);

  const [limit, setLimit] = React.useState<number>(10);
  const [offset, setOffset] = React.useState<number>(0);

  const { data, refetch } = useGetUserSystem({
    factory_id: contact?.id || "",
    search: "",
    sort_direction: "asc",
    limit: limit,
    offset: offset,
  });

  return (
    <>
      <Row className="rowgap-vbox" gutter={[24, 0]}>
        <Col span={24}>
          <Card bordered={false} className="criclebox h-full tabs-mobile">
            <HeaderTabs>
              <IconWrapper
                onClick={() => {
                  navigate("/setting");
                }}
              >
                <SpanIcon>{goBack}</SpanIcon>
              </IconWrapper>
              <Typography.Title level={5}>ผู้ใช้งานระบบ</Typography.Title>
              <RightIconWrapper></RightIconWrapper>
            </HeaderTabs>
            <>
              <TitleWrapper>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: 16,
                    width: "100%",
                    padding: 10,
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "flex-end",
                      gap: 16,
                    }}
                  >
                    <ModalAddUser />
                  </div>
                </div>
              </TitleWrapper>

              <UserSystemList
                data={data}
                refetch={refetch}
                limit={limit}
                offset={offset}
                setLimit={setLimit}
                setOffset={setOffset}
              />
            </>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default UserSystem;

const HeaderTabs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  flex-direction: row;
  border-bottom: 1px solid #efefef;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 30px;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const RightIconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  background-color: #efefef;
`;
